import { toast } from "sonner"

// Error with additional properties from API
interface ApiError extends Error {
  status?: number
  errors?: Record<string, string[]>
  originalResponse?: any
}

// Handle API errors consistently with better message extraction
export function handleApiError(error: unknown, fallbackMessage = "An unexpected error occurred") {
  console.error('API Error:', error) // For debugging
  
  const apiError = error as ApiError

  // Get the most appropriate error message
  let message = fallbackMessage
  
  if (apiError.message && apiError.message !== "Failed to fetch" && apiError.message !== "[object Object]") {
    message = apiError.message
  } else if (apiError.originalResponse?.error?.message) {
    message = apiError.originalResponse.error.message
  } else if (apiError.originalResponse?.message) {
    message = apiError.originalResponse.message
  } else if (typeof apiError.originalResponse?.error === 'string') {
    message = apiError.originalResponse.error
  }

  // Handle network errors
  if (apiError.message === "Failed to fetch") {
    message = "Network error. Please check your connection and try again."
  }

  // Show toast with error message
  toast.error(message)

  // Return the error for further handling if needed
  return apiError
}

// Format validation errors from API
export function formatValidationErrors(errors?: Record<string, string[]>): Record<string, string> {
  if (!errors) return {}

  return Object.entries(errors).reduce(
    (acc, [field, messages]) => {
      acc[field] = messages[0] // Take the first error message for each field
      return acc
    },
    {} as Record<string, string>,
  )
}
